import type { HeaderChipId } from './headerChipPrefs'

/**
 * Header chips pack to the right on a single row; overflow goes into the chips picker.
 */
export const STATUS_GRID_CLASS =
  'flex w-full min-w-0 flex-nowrap items-center justify-end gap-x-2 overflow-hidden'

const HEADER_AMOUNT_CHIP_IDS = ['balanceTotal', 'keBalanceTotal', 'balanceDue'] as const

export const isHeaderAmountChip = (id: HeaderChipId): boolean =>
  (HEADER_AMOUNT_CHIP_IDS as readonly HeaderChipId[]).includes(id)

/**
 * Amount chips size to the full currency string. Status chips stay fixed so the
 * same badge type lines up across stacked accounts.
 */
export const HEADER_CHIP_SLOT_CLASS: Record<HeaderChipId, string> = {
  balanceTotal: 'min-w-[5.75rem] w-max',
  keBalanceTotal: 'min-w-[5.75rem] w-max',
  balanceDue: 'min-w-[5.75rem] w-max',
  keAccount: 'w-[5.5rem]',
  utilityAccount: 'w-[6.5rem]',
  billingStanding: 'w-[8.5rem]',
  billingOpsStatus: 'w-[5.5rem]',
  vnemStatus: 'w-[5.5rem]',
  billingMode: 'w-[6.75rem]',
  paperless: 'w-[4.75rem]',
  autopay: 'w-[4.75rem]',
  optiRate: 'w-[4.75rem]',
}
